<template>
    <div class="pageFeed">
        <div class="section-inner mb16" v-if="isDisplay==true">
            <div class="form-column">
                <template v-if="isDisplaySort"> 
                    <label class="num04">表示順</label>
                    <select v-model="selectedDispSortNo" @change="search">
                        <option v-for="(item, index) in dispSortList" :key=index :value="item.KEY">{{item.VALUE}}</option>
                    </select>
                </template>
                
                <label class="num05">表示件数</label>
                <select v-model="pageFeedData.pageSize" @change="search" size="1">
                    <option v-for="(option, index) in dispPageSizeList" :key=index :value="option.value">{{option.text}}</option>
                </select>
            </div>
        </div>
        <slot name="TableRender"></slot>
        <ul class="pager fs mb64">
                <template v-if="dispKbn == '0'">
                    <li v-for="(page, index) in Math.ceil(pageFeedData.totalRecord/pageFeedData.pageSize)" :key=index :class="{ 'pageNow': pageFeedData.pageNo == page }">
                        <template v-if="pageFeedData.pageNo == page">
                            <font style='color:#0e0e0e;'>{{page}}</font>
                        </template>
                        <template v-else>
                            <font style='color:#4c87d1; cursor: pointer;' @click="changePageNo(page)">{{page}}</font>
                        </template>
                    </li>
                </template>
                <template v-else>
                    <template v-if="1 < calcMinPageNo">
                        <li :class="{ 'pageNow': pageFeedData.pageNo == page }">
                            <font style='color:#4c87d1; cursor: pointer;' @click="changePageNo(1)">1</font>..
                        </li>
                    </template>
                    <template v-if="pageFeedData.pageNo != 1">
                        <li>
                            <font style='color:#4c87d1; cursor: pointer;' @click="changePageNo(pageFeedData.pageNo-1)">{{$t('common.labels.previous')}}</font>
                        </li>
                    </template>
                    <li v-for="page in loopCnt" :key=page :class="{ 'pageNow': pageFeedData.pageNo == page+calcMinPageNo-1 }">
                        <template v-if="calcMinPageNo <= page+calcMinPageNo-1 && page+calcMinPageNo-1 <= calcMaxPageNo">
                            <template v-if="pageFeedData.pageNo == page+calcMinPageNo-1">
                                <font style='color:#0e0e0e;'>{{page+calcMinPageNo-1}}</font>
                            </template>
                            <template v-else>
                                <font style='color:#4c87d1; cursor: pointer;' @click="changePageNo(page+calcMinPageNo-1)">{{page+calcMinPageNo-1}}</font>
                            </template>
                        </template>
                    </li>
                    <template v-if="pageFeedData.pageNo != maxPageNo">
                        <li class="pegeNow5">
                            <font style='color:#4c87d1; cursor: pointer;' @click="changePageNo(pageFeedData.pageNo+1)">{{$t('common.labels.next')}}</font>
                        </li>
                    </template>
                    <template v-if="calcMaxPageNo < maxPageNo">
                        <li :class="{ 'pageNow': pageFeedData.pageNo == page }">
                            ..<font style='color:#4c87d1; cursor: pointer;' @click="changePageNo(maxPageNo)">{{maxPageNo}}</font>
                        </li>
                    </template>
                </template>
        </ul>
    </div>
</template>

<script>
import InputCheck from 'components/InputCheck';
/* 
* Import libs and componnents
*/
export default {
    /* 
    * Name of component
    */
    name: "PageFeed",
    /* 
    * Declare components
    */
    components: {
        InputCheck
    },
    props: {
        pageFeedData: {
            type: Object
        },
        orderByType: {
            type: [Number, String]
        },
        dispPageSizeList: {
            type: Array,
            default: function() {
                return [
                    {value: 16,text: "16件"},
                    {value: 10,text: "10件"},
                    {value: 20,text: "20件"},
                    {value: 30,text: "30件"},
                    {value: 40,text: "40件"},
                    {value: 50,text: "50件"}
                ]
            }
        },
        dispSortList: {
            type: Array,
            default: function() {
                return [
                    {"key": "1", "value": "登録日が新しい"},
                    {"key": "2", "value": "登録日が古い"},
                    {"key": "3", "value": "価格が高い"},
                    {"key": "4", "value": "価格が安い"}
                ]
            }
        },
        isDispSort: {
            type: Boolean,
            default: true
        },
        isDisplay:{
            type: Boolean,
            default: true
        },
        isDisplaySort:{
            type: Boolean,
            default: true
        }
    },
    /* 
    * Declare variable and set default value
    */
    data() {
        return {
            selectedDispSortNo: this.orderByType != undefined ? this.orderByType : 1,
            goto: null,
            calcMinPageNo:0,
            calcMaxPageNo:0,
            maxPageNo:0,
            loopCnt:0,
            dispKbn:"0"
        }
    },
    mounted() {
        this.updatePageNo(this.pageFeedData.pageNo);
	},
    /* 
    * Methods
    */
    methods: {
        search: function() {
            this.$emit('search', this.selectedDispSortNo, this.pageFeedData.pageSize, 1);
            this.updatePageNo(this.pageFeedData.pageNo);
        },
        changeDispSortNo: function() {
            this.$emit('changeDispSortNo', this.selectedDispSortNo)
        },
        changePageSize: function() {
            this.$emit('changePageSize', this.pageFeedData.pageSize)
        },
        changePageNo: function(pageNo) {
            this.$emit('search', this.selectedDispSortNo, this.pageFeedData.pageSize, pageNo);
            this.updatePageNo(pageNo);
        },
        firstPage() {
            this.pageFeedData.pageNo = 1;
            this.changePageNo();
        },
        previousPage() {
            this.pageFeedData.pageNo > 1 ? this.pageFeedData.pageNo-- : this.pageFeedData.pageNo = 1;
            this.changePageNo();
        },
        nextPage() {
            var totalPage = Math.ceil(this.pageFeedData.totalRecord/this.pageFeedData.pageSize);
            this.pageFeedData.pageNo < totalPage ? this.pageFeedData.pageNo++ : this.pageFeedData.pageNo = totalPage;
            this.changePageNo();
        },
        lastPage() {
            var totalPage = Math.ceil(this.pageFeedData.totalRecord/this.pageFeedData.pageSize);
            this.pageFeedData.pageNo = totalPage;
            this.changePageNo();
        },
        gotoPage() {
            if(this.goto == null || this.goto == "") return;
            var totalPage = Math.ceil(this.pageFeedData.totalRecord/this.pageFeedData.pageSize);
            Number(this.goto) > totalPage ? this.pageFeedData.pageNo = totalPage : this.pageFeedData.pageNo = Number(this.goto);
            this.goto = null;
            this.changePageNo();
        },
        updatePageNo: function(page) {
            //表示するページの計算
            var minNo = 0;
            var maxNo = 0;
            //今のページの左右に表示するページNoの数
            var dispSideCount = 6;
            var leftCount = dispSideCount / 2;
            var rightCount = dispSideCount / 2;
            //現在のページ
            var pageNo = page;
            //ページの最大数
            this.maxPageNo = Math.ceil(this.pageFeedData.totalRecord/this.pageFeedData.pageSize);
            var maxPageCount = Math.ceil(this.pageFeedData.totalRecord/this.pageFeedData.pageSize);

            //左右の表示数以上のページ数がある場合計算を行う
            if (maxPageCount > dispSideCount) {
                this.dispKbn = "1";
                minNo = pageNo - leftCount;
                maxNo = pageNo + rightCount;

                //計算した最小のページ数が1以下となる場合最小のページを1にする
                if(minNo < 1){
                    maxNo = minNo + (minNo * -1) + dispSideCount + 1;
                    minNo = 1; 
                //計算した最大のページ数を超えた場合
                }else if(maxNo > maxPageCount){
                    minNo = maxPageCount - dispSideCount;
                    maxNo = maxPageCount;
                }

            //計算を行う必要がない
            }else{
                this.dispKbn = "0";
            }
            this.loopCnt = maxNo - minNo + 1;
            this.calcMinPageNo = minNo;
            this.calcMaxPageNo = maxNo;
        }
    }
}
</script>

<style scoped>
.pageFeed {
    font-size:13px
}
.pageFeed .section-inner {
    padding: 5px;
}
.pageFeed .section-inner label{
    margin-bottom: 0px;
}
.pageFeed .seach-style {
    border:1px solid #AAAAAA;
    width:312px;
}
.pageFeed .seach-header-style {
    width:310px;
    background:#CCCCFF;
}
.pageFeed .goto-style{
    width:30px;
    text-align:right;
    border: 1px solid #A9A9A9;
}
</style>
